(() => {
  const popup = document.querySelector('[data-global-event-popup]');
  if (!popup) return;

  const closePopup = () => {
    if (popup.classList.contains('is-closing') || popup.classList.contains('is-hidden')) return;
    popup.classList.add('is-closing');
    document.body.classList.remove('owl-global-event-popup-open');
    window.setTimeout(() => {
      popup.classList.add('is-hidden');
      popup.classList.remove('is-closing');
    }, 200);
  };

  document.body.classList.add('owl-global-event-popup-open');

  popup.querySelectorAll('[data-global-event-popup-close]').forEach((button) => {
    button.addEventListener('click', closePopup);
  });

  popup.querySelectorAll('[data-global-event-popup-link]').forEach((link) => {
    link.addEventListener('click', closePopup);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !popup.classList.contains('is-hidden')) {
      closePopup();
    }
  });
})();
